// types.js
export const SET_SIDEBAR_COLLAPSE = 'SET_SIDEBAR_COLLAPSE';
